/**
 * Big spinner for when an entire page or module is loading
 */
export const FullPageSpinner = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="loading loading-spinner loading-xl text-primary" />
    </div>
  );
};
